import React from 'react';
import PropTypes from 'prop-types';
import { LocaleService } from '@sm360/widget-commons-core-services';

import { Quote, CurrencyFormats } from '@sm360/widget-commons-vehicle';

const GarageCashPurchase = ({ quote }) => {
    const { cashPurchase } = quote;
    const { incentives, sellingPrice: retail } = cashPurchase;
    const purchaseMethodLabels = {
        name: LocaleService.t('purchaseMethods.cashPurchase'),
        verb: LocaleService.t('purchaseMethods.cashPurchaseVerb'),
    };
    const { total: rebates } = incentives;
    const calculatedFormattedRetail = retail > 0 ? LocaleService.l(retail, CurrencyFormats.CURRENCY_2) : '';
    const calculatedFormattedRebates = rebates > 0 ? LocaleService.l(rebates, CurrencyFormats.CURRENCY_2) : '';

    return (
        <div className="payment-wrapper">
            <p className="sr-text is-bold payment-title">
                {purchaseMethodLabels.verb}
                <span> {calculatedFormattedRetail}</span>
            </p>
            {calculatedFormattedRebates && (
                <div className="vehicle-rebate">
                    <icon className="icon-promo2 is-price" />
                    <p>
                        {LocaleService.t('GARAGE.VEHICLE_STATUS.BONUS_REBATE', { rebate: calculatedFormattedRebates })}
                    </p>
                </div>
            )}
        </div>
    );
};

GarageCashPurchase.propTypes = {
    quote: PropTypes.instanceOf(Quote.QuoteModelV25).isRequired,
};

GarageCashPurchase.displayName = 'GarageCashPurchase';

export default GarageCashPurchase;
